import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  DialogTitle,
  DialogActions,
  Button,
  Box,
  CircularProgress,
  Typography,
  Divider,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  Paper,
  Chip,
  Grid
} from '@mui/material';
import { Visibility, Star, Schedule } from '@mui/icons-material';
import { editView, setSiteList } from '../../ducks/actions';
import { getSelectLoading, getAvailableViews, getCurrentView, getDialogSubtype } from '../../ducks/selectors';
import PrimaryList from './PrimaryList';
import ViewManagementSiteList from './siteList';
import { getSiteList } from 'modules/cbre-flow-site-location/ducks/actions';
import { getSiteInfoUrl } from 'modules/cbre-flow-site-location/ducks/selectors';
import { getUserAccess } from 'modules/cbre-flow-api-ducks/selectors';
import { DIALOG_SUBTYPES } from 'modules/cbre-flow-view-management/ducks/constants';
import ViewManagementCostCenterList from './costCenterList';

interface View {
  id: string;
  name: string;
  description?: string;
  isDefault?: boolean;
  isSystem?: boolean;
  createdAt?: string;
}

interface ViewEditContentProps {
  onClose: () => void;
  apiUrl: string;
}

const ViewEditContent: React.FC<ViewEditContentProps> = ({
  onClose,
  apiUrl
}) => {
  const { client } = useSelector(getUserAccess);
  const dispatch = useDispatch();
  const currentView = useSelector(getCurrentView) as string;
  const subType = useSelector(getDialogSubtype);
  const [selectedViewId, setSelectedViewId] = useState<string>(currentView || '');
  const [selectedClient, setSelectedClient] = useState<any>(client);

  const handleApplyView = () => {
    if (selectedViewId) {
      dispatch(editView({ apiUrl, viewId: selectedViewId }));
    }
  };

  if (subType === DIALOG_SUBTYPES.EDIT_PRIMARY_LIST) {
    return <PrimaryList selectedClient={selectedClient} setSelectedClient={setSelectedClient} />;
  }
  if (subType === DIALOG_SUBTYPES.EDIT_SITE_LIST ) {
    return <ViewManagementSiteList selectedClient={selectedClient}/>;
  }

  if(subType === DIALOG_SUBTYPES.EDIT_COST_CENTER_LIST ){
    return <ViewManagementCostCenterList selectedClient={selectedClient}/>;
  }

  return (
    <>

    </>
  );
};

export default ViewEditContent;